var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full flex justify-center items-center"},[_c('div',{staticClass:"is-submiting"})])
}]

export { render, staticRenderFns }